<template>
  <div v-if="cur_group.name !== undefined" class="simcard-group__config">
    <div class="simcard-group__config-header">
      <fg-input
        v-model="cur_group.name"
        class="name"
        type="text"
        placeholder="name group"
        @keydown.enter="save_simcard"
      />
      <button
          type="submit"
          class="mdi mdi-content-save btn btn-success"
          @click.prevent="save_simcard"
          :disabled="check_change"
      >
        <b>{{translate('config.save')}}</b>
      </button>

      <router-link class="mdi mdi-eye btn btn-success" :to="open_simcard_devices_group(cur_group.id)">
        <b>{{translate('config.show_group_simcards_devices')}}</b>
      </router-link>
    </div>

      <div class="simcard-group__config-main">

          <div class="form-group">
            <label>
              {{translate('device.config.client')}}
            </label>
            <tree-select
                v-model="cur_group.client_id"
                :options="client_list"
                :placeholder="translate('device.config.client')"
                :disabled="!this.$store.getters.getPermissions.editDeviceGroups === true"
                :clearable="false"
            />
          </div>

          <fg-input
              v-model="cur_group.user_name"
              class="name"
              type="text"
              :label="translate('simcard_devices.config.user')"
              :placeholder="translate('simcard_devices.config.username')"
              :readonly="true"
          />

          <fg-input
              v-model="created"
              class="name"
              type="text"
              :label="translate('simcard_devices.config.created')"
              :placeholder="translate('simcard_devices.config.created')"
              :readonly="true"
          />
          <fg-input
              v-model="updated"
              class="name"
              type="text"
              :label="translate('simcard_devices.config.updated')"
              :placeholder="translate('simcard_devices.config.updated')"
              :readonly="true"
          />
      </div>
  </div>
</template>

<script>

import Treeselect from "@riophae/vue-treeselect";

export default {
  name: 'SimCardDevicesGroupInfo',
  components: {
      Treeselect
  },
  props: ['group'],
  data () {
    return {
      cur_group: {}
    }
  },
  computed:{
      created(){
          return this.cur_group.ts_create ? this.get_date(this.cur_group.ts_create) : ''
      },
      updated(){
          return this.cur_group.ts_update ? this.get_date(this.cur_group.ts_update) : ''
      },
      check_change(){
        return !(((this.group.client_id !== this.cur_group.client_id) && (this.cur_group.client_id !== '')) || this.group.name !== this.cur_group.name)
      },
      client_list(){
        let list = []
        for (let client of this.$store.getters.getClientsList) {
          list.push({id: client.id, label: client.name })
        }
        return list
      },
  },
  watch: {
    group () {
      if (Object.keys(this.group).length > 0 ) {
        this.cur_group = {...this.group}
      }else{
        this.cur_group = {}
      }
    }
  },
  methods: {

    open_simcard_devices_group(id){
      return {path: '/simcard_devices_list?group=' + id}
    },
    save_simcard () {
      this.$http.v1.updateSimcardGroup({...this.cur_group},() => {
          this.global_notify('info', this.translate('simcard_devices_groups.update'))
          this.$store.dispatch('groupSimcardDevicesUpdate')
      })
    },
  }
}
</script>

<style lang='scss' scoped>
  .simcard-group{
    &__config{
      display: flex;
      flex-direction: column;
      overflow: hidden;
      height: 100%;
      padding: 10px;
      &-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        .name{
          width: 50%;
          margin-bottom: 0;
        }
        .btn{
          padding: 7px;
        }
      }
      &-main{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        .form-group{
          width: 50%;
          padding: 5px;
          margin: 0;
        }
      }
    }
  }

  @media (max-width:768px) {
    .simcard-group{
      &__config{
      padding: 10px 0;
        &-header{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .name{
            width: 70%;
            margin-bottom: 0;
          }
          .btn{
            width: 15%;
            margin-left: 10px;
            padding: 7px;
            b{
              display: none;
            }
          }
        }
      }
    }
  }

</style>
